import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ClubMembers.css';

const ClubMembers = () => {
  const coreLeadership = [
    { name: 'Paul Selborg', role: 'President', image: '../../../Images/IMG_1749.PNG' },
    { name: 'Devin Llanas', role: 'Vice President', image: '../../../Images/ClubMember12.png' },
    { name: 'Srikar', role: 'Support Team Coordinator', image: '../../../Images/srikar.png' },
{ name: 'Jack Kirmeier', role: 'Operations Lead', image: '../../../Images/IMG_1824.jpg' },
    { name: 'Chris Naber', role: 'General Manager', image: '../../../Images/ClubMemberTwo.png' },

  ];

  const functionalCommittee = [
    { name: 'Kale Kimmel', role: 'Web Designer', image: '../../../Images/IMG_0098 (2).PNG' },
    { name: 'Rudy Wicker', role: 'Philanthropy Manager', image: '../../../Images/IMG_0630.PNG' },
    { name: 'Pranniel Thankavel', role: 'Spiritual Advisor', image: '../../../Images/ClubMember14.png' },
    { name: 'Charles Pfennigwert', role: 'Morale Advisor', image: '../../../Images/IMG_1746 (1).PNG' },
    { name: 'Alex Roberts', role: 'Accountant', image: '../../../Images/ALex.png' },
    { name: 'Will Guerrero', role: 'Expansion Coordinator', image: '../../../Images/Will.PNG' },
    { name: 'Ruben Mendes', role: 'Financial Advisor', image: '../../../Images/IMG_4428.jpeg' },
  ];

  return (
    <Container className='club-members-container'>
      <div className='header-section text-center'>
        <h2 className='title'>Club Leaders</h2>
        <p className='subtitle'>Meet the dedicated leaders of our club.</p>
      </div>
      
      {/* Core Leadership Section */}
      <div className='leadership-section text-center my-4'>
        <h3>Core Leadership</h3>
        <Row className='my-4'>
          {coreLeadership.map((member, index) => (
            <Col md={3} className='text-center' key={index}>
              <div className='member-img-container'>
                <img src={member.image} alt={member.name} className='member-img' />
              </div>
              <h4 className='mt-3'>{member.name}</h4>
              <p>{member.role}</p>
            </Col>
          ))}
        </Row>
      </div>
      
      {/* Functional Committee Section */}
      <div className='committee-section text-center my-4'>
        <h3>Functional Committee</h3>
        <Row className='my-4'>
          {functionalCommittee.map((member, index) => (
            <Col md={3} className='text-center' key={index}>
              <div className='member-img-container'>
                <img src={member.image} alt={member.name} className='member-img' />
              </div>
              <h4 className='mt-3'>{member.name}</h4>
              <p>{member.role}</p>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default ClubMembers;